__turbopack_context__.v({
  "action": "CompactArticleView-module-scss-module__k0F4Ka__action",
  "actionIcon": "CompactArticleView-module-scss-module__k0F4Ka__actionIcon",
  "badge": "CompactArticleView-module-scss-module__k0F4Ka__badge",
  "card": "CompactArticleView-module-scss-module__k0F4Ka__card",
  "link": "CompactArticleView-module-scss-module__k0F4Ka__link",
  "subtitle": "CompactArticleView-module-scss-module__k0F4Ka__subtitle",
  "title": "CompactArticleView-module-scss-module__k0F4Ka__title",
});
